import { WizardStepPage } from '../WizardStepPage/view';
import { DeviceBarcodeStepView } from '../DeviceBarcodeStepView/view';
import { MachineQGatewayStepView } from '../DeviceBarcodeStepView/MachineQDeviceStepView/MachineQGatewayStepView/view';
import { SensorPlacement } from '../../../../backbone-unorganized/shared/sensors/models';

export const DeviceNameStepView = WizardStepPage.extend({
    template: '#tpl_device_name_step',
    nextStepViewClass: DeviceBarcodeStepView,
    stepTitleKey: 'mobile_sensors_name_this_gateway',
    selectedManufacturer: null,
    placement: SensorPlacement, // SensorPlacement,
    placement_nicknames: [],

    events: $.extend(
        { 'keyup .watched_input': 'titleChanged', 'change select': 'setTitleFromSelect' },
        WizardStepPage.prototype.events
    ),

    templateHelpers: function () {
        const helpers = DeviceNameStepView.__super__.templateHelpers.apply(this, arguments);
        return $.extend(helpers, {
            nicknames: this.isSensorModel() ? this.placement.get('sensor_placement_nicknames') : null
        });
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
        DeviceNameStepView.__super__.initialize.apply(this, arguments);

        this.stepTitleKey = `mobile_sensors_name_this_${this.isSensorModel() ? 'sensor' : 'gateway'}`;
        // Only load placement data is this is a sensor
        if (this.isSensorModel()) {
            this.loadSensorPlacementData();
        }
    },

    loadSensorPlacementData: async function () {
        await this.fetchPlacement();
        this.render();
        if (this.placement.get('sensor_placement_nicknames').length >= 1) {
            this.setTitleToSingleNickname(this.placement.get('sensor_placement_nicknames')[0].name);
        }
    },

    fetchPlacement: function () {
        this.placement = new SensorPlacement({ id: this.model.get('placement').get('id') });

        return new Promise((resolve, reject) => {
            this.placement.fetch({
                success: resolve,
                error: reject
            });
        });
    },

    onRender: function () {
        this.updateNextButtonState(this._nextButtonIsEnabled());
    },

    titleChanged: function (event) {
        const target = $(event.target);
        this.model.set('name', target.val());
        this.updateNextButtonState(this._nextButtonIsEnabled());
    },

    setTitleFromSelect: function (event) {
        const target = $(event.target);
        this.model.set('name', target.val());
        this.updateNextButtonState(this._nextButtonIsEnabled());
    },

    setTitleToSingleNickname: function (nickname) {
        this.model.set('name', nickname);
        this.updateNextButtonState(this._nextButtonIsEnabled());
    },

    _nextButtonIsEnabled: function () {
        return this.model.get('name')?.trim()?.length > 0;
    },

    displayNextStep: function () {
        let nextStepView = DeviceBarcodeStepView;

        if (this.selectedManufacturer === $f.mobile.sensors.util.INTEGRATION_TYPE.MACHINEQ && !this.isSensorModel()) {
            nextStepView = MachineQGatewayStepView;
        }

        $f.mobile.nav.show(nextStepView, {
            model: this.model,
            stepNumberKey: this.nextStepNumberKey,
            selectedManufacturer: this.selectedManufacturer
        });
    }
});
